<div [ngClass]="theme">
  <ng-progress #progressBar></ng-progress>
  <router-outlet #o="outlet" *ngIf="!isIframe"></router-outlet>
</div>